<div class="modal-header" cdkDrag cdkDragRootElement=".modal-content" cdkDragHandle>
  <h5 class="modal-title">Pre-Submission Checklist</h5>
  <button type="button" class="btn-close" aria-label="Close" (click)="activeModal.dismiss()"></button>
</div>

<div class="modal-body">

  <div *ngIf="error" class="alert alert-danger">{{errorMessage}}</div>

  <div *ngIf="!error">
    <div *ngFor="let item of items" class="d-flex align-items-center border-bottom py-2 gap-3">

      <div class="flex-grow-1 small" [innerHTML]="item.preSubmissionChecklistItem.itemText"></div>

      <div class="d-flex align-items-center gap-2 flex-shrink-0">
        <div class="btn-group" role="group">
          <input type="radio" class="btn-check" [name]="'response_' + item.id" [id]="'yes_' + item.id"
            [value]="1" [(ngModel)]="item.checklistResponseType" (ngModelChange)="updateValue(item)">
          <label class="btn btn-outline-success btn-sm" [for]="'yes_' + item.id">Yes</label>

          <input type="radio" class="btn-check" [name]="'response_' + item.id" [id]="'no_' + item.id"
            [value]="2" [(ngModel)]="item.checklistResponseType" (ngModelChange)="updateValue(item)">
          <label class="btn btn-outline-success btn-sm" [for]="'no_' + item.id">No</label>

          <input type="radio" class="btn-check" [name]="'response_' + item.id" [id]="'na_' + item.id"
            [value]="3" [(ngModel)]="item.checklistResponseType" (ngModelChange)="updateValue(item)">
          <label class="btn btn-outline-success btn-sm" [for]="'na_' + item.id">N/A</label>

          <input type="radio" class="btn-check" [name]="'response_' + item.id" [id]="'tf_' + item.id"
            [value]="4" [(ngModel)]="item.checklistResponseType" (ngModelChange)="updateValue(item)">
          <label class="btn btn-outline-success btn-sm" [for]="'tf_' + item.id">To Follow</label>
        </div>

        <!-- Fixed width container so layout doesn't shift -->
        <div style="width: 32px;">
          <button *ngIf="item.checklistResponseType" type="button"
            class="btn btn-secondary btn-sm"
            (click)="clearValue(item)">
            <fa-icon [icon]="faTimes"></fa-icon>
          </button>
        </div>
      </div>

    </div>
  </div>

</div>

<div class="modal-footer" *ngIf="!error">
  <button *ngIf="!generatingPDF" type="button" class="btn btn-success" (click)="generatePDF()">
    Generate PDF
  </button>
  <button *ngIf="generatingPDF" type="button" class="btn btn-success" disabled>
    <span class="spinner-border spinner-border-sm" role="status"></span>
    Generating...
  </button>
</div>